import React from "react";
import {
  Modal,
  Box,
  SpaceBetween,
  Header,
  Button,
  Table,
} from "@amzn/awsui-components-react";



const FriscoJobErrors = (props) =>{
  return (
	<>
        <Table
        columnDefinitions={props.columnDefinitions}
        enableKeyboardNavigation
        sortingDescending
        stripedRows
        items={props.errorData}
        loadingText="Checking for Errors"
        trackBy="name"
        empty={
            <Box
                margin={{ vertical: "xs" }}
                textAlign="center"
                color="inherit"
            >
                <SpaceBetween size="m">
                    <b>No Errors Found</b>
                </SpaceBetween>
            </Box>
        }
        header={<Header>{props.header}</Header>}
        />
	</>
  );
}

export default FriscoJobErrors;